import { AuthenticationModule, MobileScreenModule } from '@serviceos-ng/shared-modules';
import {
    AuthenticateGuard,
    CarouselSliderModule,
    LinkModule,
    LogoModule,
    LogoutGuardGuard,
    NavigationStoreModule,
    SosAuthorizationStoreModule,
    SosCoreModule,
    SosFrameModule,
    SosLoaderModule,
} from '@serviceos-ng/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginScreenComponent } from './login-screen/login-screen.component';
import { ClaimAccountScreenComponent } from './claim-account-screen/claim-account-screen.component';
import { CreateAccountScreenComponent } from './create-account-screen/create-account-screen.component';
import { ForgottenPasswordScreenComponent } from './forgotten-password-screen/forgotten-password-screen.component';

import { RouterModule, Routes } from '@angular/router';
import { RecoverPasswordScreenComponent } from './recover-password-screen/recover-password-screen.component';
import { FooterScreenComponent } from './shared/footer-screen/footer-screen.component';
import { HeaderScreenComponent } from './shared/header-screen/header-screen.component';

const routes: Routes = [
    {
        path: 'login',
        component: LoginScreenComponent,
    },
    {
        path: 'create-account',
        component: CreateAccountScreenComponent,
    },
    {
        path: 'create-account/:id',
        component: CreateAccountScreenComponent,
    },
    {
        path: 'claim-account',
        component: ClaimAccountScreenComponent,
    },
    {
        path: 'forgot-password',
        component: ForgottenPasswordScreenComponent,
    },
    {
        path: 'recover-password/:id',
        component: RecoverPasswordScreenComponent,
    },
    {
        path: 'logout',
        canActivate: [LogoutGuardGuard],
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'login',
    },
];

@NgModule({
    declarations: [
        LoginScreenComponent,
        ClaimAccountScreenComponent,
        CreateAccountScreenComponent,
        ForgottenPasswordScreenComponent,
        RecoverPasswordScreenComponent,
        FooterScreenComponent,
        HeaderScreenComponent
    ],
    imports: [
        CommonModule,
        SosCoreModule,
        RouterModule.forChild(routes),
        SosAuthorizationStoreModule,
        NavigationStoreModule,
        AuthenticationModule,
        SosFrameModule,
        LinkModule,
        LogoModule,
        SosLoaderModule,
        MobileScreenModule,
        CarouselSliderModule
    ],
    exports: [
        LoginScreenComponent,
        ClaimAccountScreenComponent,
        CreateAccountScreenComponent,
        ForgottenPasswordScreenComponent,
        RecoverPasswordScreenComponent,
    ],
})
export class AuthenticationScreensModule {}
